/*
 * T-17-01 · LOS PERFILES DEL SELECTOR CON BUSCADOR (D-358, RF-230, RN-651,
 * RN-658; contrato de uso §2.2 de `analisis/contratos-edicion-movimientos-y-selectores.md`).
 *
 * UN PERFIL ES ESTA TABLA Y NADA MÁS: identidad de la opción, función de filtrado,
 * descripción visible, descripción para el lector, texto que queda en el campo al
 * elegir, textos de petición, de «sin coincidencias», nombre accesible de la lista
 * y anuncio de coincidencias.
 *
 * LO QUE UN PERFIL NO PUEDE CONTENER, y cada cosa sería un defecto:
 *   · JSX con estructura propia · manejo de teclado · manejo de foco · estados de
 *     apertura o de carga · llamadas a la red · acceso a almacenamiento
 *   · NI OPCIONES QUE NO SEAN DATOS DEL CATÁLOGO: una «opción-renglón» sintética
 *     tipo «Todas» está derogada (D-369, RN-680). La semántica «todas» es el VALOR
 *     VACÍO y vive en el consumidor (RN-677).
 *
 * Si una necesidad futura no cabe aquí, se amplía EL CONTROL —una vez, para
 * todos—, nunca se escribe un segundo componente (RN-658).
 *
 * LOS DOS PERFILES SON OBJETOS CONGELADOS Y CONSTANTES: no se construyen por
 * render y no se parametrizan por consumidor. Lo único que un consumidor puede
 * pedir distinto es el TEXTO DE PETICIÓN, que ya era entrada del combobox del
 * 11/16 («Elige la cuenta…» en la captura, «Todas las cuentas del hogar» en el
 * filtro) y sigue siendo un dato, no una conducta.
 */

import {
  anunciarCoincidencias,
  describirCuenta,
  describirCuentaParaLector,
  filtrarCuentas,
} from './filtradoDeCuentas.js';
import {
  anunciarCategoriasCoincidentes,
  describirCategoria,
  describirCategoriaParaLector,
  filtrarCategorias,
} from './filtradoDeCategorias.js';

/**
 * PERFIL DE CUENTA · el del 11/16, tal cual, reusando `filtradoDeCuentas.js` sin
 * tocarlo (RN-651). El renglón sigue mostrando nombre arriba y
 * «tipo · ••1234 · importe» debajo (RF-179, RN-544), que es lo que ya se
 * mostraba y no se quita.
 */
export const PERFIL_DE_CUENTA = Object.freeze({
  nombreDelPerfil: 'cuenta',
  claveDeIdentidad: 'idCuenta',
  filtrar: filtrarCuentas,
  textoEnElCampo: (cuenta) => cuenta?.nombre ?? '',
  describirNombre: (cuenta) => cuenta?.nombre ?? '',
  describirDatos: describirCuenta,
  describirParaLector: describirCuentaParaLector,
  textoDePeticion: 'Elige la cuenta…',
  textoSinCoincidencias: (texto) => `Ninguna cuenta coincide con “${texto}”`,
  nombreAccesibleDeLaLista: 'Cuentas que coinciden',
  anunciarCoincidencias,
});

/**
 * PERFIL DE CATEGORÍA · nuevo (RF-231, RF-232, RF-245, RN-652 a RN-657, RN-678).
 * El renglón muestra SOLO el nombre, con « · desactivada» cuando la categoría
 * llega inactiva —rama que solo corre en el filtro del historial—.
 */
export const PERFIL_DE_CATEGORIA = Object.freeze({
  nombreDelPerfil: 'categoria',
  claveDeIdentidad: 'idCategoria',
  filtrar: filtrarCategorias,
  textoEnElCampo: (categoria) => categoria?.nombre ?? '',
  describirNombre: describirCategoria,
  // RF-232 · La opción de categoría no gana una segunda línea de datos: lo que el
  // desplegable nativo mostraba era el nombre y eso es lo que se conserva.
  describirDatos: () => '',
  describirParaLector: describirCategoriaParaLector,
  textoDePeticion: 'Elige una categoría…',
  textoSinCoincidencias: (texto) => `Ninguna categoría coincide con “${texto}”`,
  nombreAccesibleDeLaLista: 'Categorías que coinciden',
  anunciarCoincidencias: anunciarCategoriasCoincidentes,
});
